import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';


// Minimal replacement for react-router-bootstrap's LinkContainer:
// makes the single child element navigate to `to` on click.
const LinkContainer = ({ to, onClick, children }) => {
  const navigate = useNavigate();
  const child = React.Children.only(children);

  const handleClick = (event) => {
    if (child.props.onClick) {
      child.props.onClick(event);
    }
    if (onClick) {
      onClick(event);
    }
    if (!event.defaultPrevented) {
      event.preventDefault();
      navigate(to);
    }
  };

  return React.cloneElement(child, { onClick: handleClick });
};

LinkContainer.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  onClick: PropTypes.func,
  children: PropTypes.element.isRequired,
};

export default LinkContainer;
